import { logItError, logItInfo } from "@fokused-me/core";
import "whatwg-fetch";

export const fetchWithTimeout = (url, options?, timeout = 10000) => {
   return Promise.race([
      fetch(url, options),
      new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), timeout)),
   ]) as Promise<Response>;
};

export function findReactElementByNode(node) {
   for (const key in node) {
      if (key.startsWith("__reactInternalInstance$")) {
         return node[key].return.stateNode;
      }
   }
}

export function execAsync<I, O>(input: I, handler: (I) => void): Promise<O> {
   const code = `onmessage = function(e) {
         let result=(${handler.toString()})(e.data);
         postMessage(result);
         close();
      };`;
   const blob = new Blob([code]);
   const worker = new Worker(URL.createObjectURL(blob));

   const promise = new Promise<O>((resolve) => {
      worker.onmessage = (e) => {
         resolve(e.data);
      };
   });

   worker.postMessage(input);
   return promise;
}

export const deleteDatabase = (name: string) =>
   new Promise<void>((resolve) => {
      const req = indexedDB.deleteDatabase(name);
      req.onsuccess = () => {
         logItInfo(`Deleted database ${name} successfully`);
         resolve();
      };
      req.onerror = () => {
         logItError(`Couldn't delete database ${name}`);
         resolve();
      };
      req.onblocked = () => {
         logItError(`Couldn't delete database ${name} due to the operation being blocked`);
         resolve();
      };
   });

export const cumulativeOffset = (element) => {
   let top = 0;
   let left = 0;
   do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
   } while (element);

   return {
      top,
      left,
   };
};
